import React from "react";

const FMCGImages = [
  {
    href: "https://inimexshop.com/en/collections/varta",
    src: `${process.env.PUBLIC_URL}/images/varta.svg`,
    alt: "Varta Logo",
    name: "Varta",
  },
  {
    href: "https://inimexshop.com/en/collections/glysolid",
    src: `${process.env.PUBLIC_URL}/images/glysolid.jpeg`,
    alt: "Glysolid Logo",
    name: "Glysolid",
  },
  {
    href: "https://inimexshop.com/en/collections/kamill",
    src: `${process.env.PUBLIC_URL}/images/kamill.svg`,
    alt: "Kamill Logo",
    name: "Kamill",
  },
  {
    href: "https://inimexshop.com/en/collections/bambo-natur",
    src: `${process.env.PUBLIC_URL}/images/bambo.svg`,
    alt: "Bambo Nature Logo",
    name: "Bambo Nature",
  },
  {
    href: "https://inimexshop.com/en/collections/abena",
    src: `${process.env.PUBLIC_URL}/images/abena.svg`,
    alt: "ABENA Logo",
    name: "ABENA",
  },
  {
    href: "https://inimexshop.com/en/collections/lion",
    src: `${process.env.PUBLIC_URL}/images/lion.svg`,
    alt: "Lion Logo",
    name: "Lion",
  },
  {
    href: "https://inimexshop.com/en/collections/zinc",
    src: `${process.env.PUBLIC_URL}/images/zinc.svg`,
    alt: "Zinc Logo",
    name: "Zinc",
  },
  {
    href: "https://inimexshop.com/en/collections/emeron",
    src: `${process.env.PUBLIC_URL}/images/emeron.svg`,
    alt: "Emeron Logo",
    name: "Emeron",
  },
  {
    href: "https://inimexshop.com/en/collections/kodomo",
    src: `${process.env.PUBLIC_URL}/images/kodomo.svg`,
    alt: "Kodomo Logo",
    name: "Kodomo",
  },
  {
    href: "https://inimexshop.com/en/collections/ciptadent",
    src: `${process.env.PUBLIC_URL}/images/ciptadent.svg`,
    alt: "Ciptadent Logo",
    name: "Ciptadent",
  },
  {
    href: "https://inimexshop.com/en/collections/pasta",
    src: `${process.env.PUBLIC_URL}/images/agnesi.svg`,
    alt: "Agnesi Logo",
    name: "Agnesi",
  },
  {
    href: "https://inimexshop.com/en/collections/parachute",
    src: `${process.env.PUBLIC_URL}/images/parachute.svg`,
    alt: "Parachute Logo",
    name: "Parachute",
  },
];

const FMCG: React.FC = () => {
  return (
    <main className="min-h-screen w-full bg-gray-100">
      <div className="w-full mx-auto px-6 py-20 max-w-full">
        {/* FMCG Section */}

        {/* FMCG Background Banner with centered text overlay */}
        <div className="w-full mb-12 relative flex items-center justify-center">
          <img
            src={`${process.env.PUBLIC_URL}/images/fmcgbg.jpeg`}
            alt="FMCG Background"
            className="w-full h-40 object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-lg md:text-2xl font-semibold text-center text-[#0f145b]">
              A diverse portfolio of trusted international brands.
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16 mt-8">
          {FMCGImages.map((img, idx) => (
            <div className="rounded-lg overflow-hidden" key={idx}>
              <a href={img.href} target="_blank" rel="noopener noreferrer">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-56 h-40 object-contain hover:opacity-80 transition p-4 cursor-pointer mx-auto"
                />
                {/* Removed brand name under image */}
              </a>
            </div>
          ))}
        </div>
        {/* FMCG1 full-width responsive image */}
        <div className="w-full mt-12" style={{ marginBottom: 0 }}>
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={`${process.env.PUBLIC_URL}/images/fmcglaptop.jpeg`}
            />
            <source
              media="(min-width: 640px)"
              srcSet={`${process.env.PUBLIC_URL}/images/fmcgtablet.jpeg`}
            />
            <img
              src={`${process.env.PUBLIC_URL}/images/fmcgmobile.jpeg`}
              alt="FMCG Banner"
              className="w-full h-[30rem] object-contain rounded-lg bg-white"
              style={{ objectPosition: "center" }}
            />
          </picture>
        </div>
      </div>
    </main>
  );
};

export default FMCG;
